module.exports = __webpack_public_path__ + "img/popshop-vid.0dda2192.gif";